
import { trimString } from '@/assets/script/utils/index.js'

export default {
  name: 'Highlight',
  props: {
    author: {
      type: Object,
      required: true,
    },
  },
  methods: {
    trimString,
  },
}
